import { useState, useEffect } from "react";
import { loadProductListBudgetPlanningDetail } from "../services/Product";

const useProductListBudgetPlanDetail = (editID) => {

    const [planningDetailList, setPlanningDetailList] = useState([]);
    const [isMaterialCategoryDataLoaded, setIsMaterialCategoryDataLoaded] = useState(false);

    // Fetch department data
    const fetchProduct = async (productID) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_productvariety_id: productID };

        try {
            const data = await loadProductListBudgetPlanningDetail(para);
            if (data && data.length > 0) {
                setPlanningDetailList(data);
                setIsMaterialCategoryDataLoaded(true);
            }
            else{
                setPlanningDetailList([]);
                setIsMaterialCategoryDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCategoryDataLoaded && editID !== 0) {
            fetchProduct(editID);
        }
    }, [isMaterialCategoryDataLoaded, editID]);

    const loadProductWisePlanDetail = (productID) => {
        fetchProduct(productID);
    }

    return {
        planningDetailList,
        setPlanningDetailList,
        loadProductWisePlanDetail,
    };
};

export default useProductListBudgetPlanDetail;